<app-data-form class="w-full" [apiUrl]="formConfig?.apiUrl" [formUrl]="formConfig?.formUrl"
    [formFields]="formConfig?.formFields" [dictionary]="formConfig?.dictionary"
    [submitActions]="formConfig?.submitActions" [idField]="formConfig?.idField" [skipApi]="formConfig?.skipApi"
    [keepOpen]="formConfig?.keepOpen" [keepOpenWithoutReset]="formConfig?.keepOpenWithoutReset"
    [hideSubmit]="formConfig?.hideSubmitButton" [model]="formConfig?.model"
    [title]="formConfig?.title" [description]="formConfig?.description"
    [addExtension]="formConfig?.addExtension ?? true" [includeFieldsInPayload]="formConfig?.includeFieldsInPayload ?? []"
    (submitForm)="onSubmitForm($event)" (cancelForm)="onCancelForm()">
</app-data-form>